import React from "react";
import { GradientSpan, H1, P2, P3 } from "../../components/theme/text/Headings";
import logoImg from "../../images/logo/v.png";

import {
  Blue,
  NeonGreen,
  OffWhite,
  Pink,
  White,
} from "../../components/theme/colors";

const TermsOfService = () => {
  return (
    <div>
      <div
        style={{
          position: "relative",
          minHeight: "100vh",
          padding: "10vh 50px 100px 50px",
          backgroundColor: "#000",
          color: White,
        }}
      >
        {/* Centered logo */}
        <a className="text-decoration-none" href="https://www.vibecheckme.com">
          <img src={logoImg} alt="Vibe Check Logo" style={{ height: "50px" }} />
        </a>
        <H1 className="mt-10" color={White}>
          <GradientSpan $background={NeonGreen} $transitionBackground={Blue}>
            Terms of Service
          </GradientSpan>{" "}
        </H1>

        <P2 color={White} className="mt-10">
          Effective Date: June 1st, 2025
        </P2>

        <H1 className="mt-50">1. Definitions</H1>
        <P2 color={White} className="mt-10">
          "Service" means the Vibe Check app, website, and related services.
          "User" means any person accessing or using the Service. "Content"
          means all quizzes, results, text, images, and materials within the
          Service. "User Content" means any content submitted by Users,
          including quiz responses.
        </P2>

        <H1 className="mt-50">2. Acceptance of Terms</H1>
        <P2 color={White} className="mt-10">
          These Terms of Service (“Terms”) constitute a legally binding
          agreement between you (“User”, “you”, or “your”) and Clickbait
          Creative, LLC (“Vibe Check”, “we”, “us”, or “our”) governing your use
          of the Service. By accessing or using the Service, you agree to these
          Terms. If you do not agree, do not use the Service.
        </P2>

        <H1 className="mt-50">3. Eligibility</H1>
        <P2 color={White} className="mt-10">
          You must be at least 17 years old (or the age of majority in your
          jurisdiction) to use Vibe Check. By using the Service, you represent
          that you meet these requirements. If you are under 18, you must have
          parental consent.
        </P2>

        <H1 className="mt-50">4. Account Registration & Security</H1>
        <P2 color={White} className="mt-10">
          You agree to provide accurate and complete information during
          registration. You are responsible for maintaining the confidentiality
          of your login credentials. You agree to notify us immediately of any
          unauthorized use of your account. We may suspend or terminate your
          account for any breach of these Terms.
        </P2>

        <H1 className="mt-50">5. User Conduct</H1>
        <P2 color={White} className="mt-10">
          You agree not to:
          <ul>
            <li>Violate any laws or regulations</li>
            <li>Upload or distribute offensive, abusive, or illegal content</li>
            <li>
              Attempt to access another user’s account without authorization
            </li>
            <li>Reverse-engineer or tamper with the Service or its security</li>
          </ul>
        </P2>

        <H1 className="mt-50">6. User-Generated Content</H1>
        <P2 color={White} className="mt-10">
          By submitting User Content, you grant Vibe Check a worldwide,
          non-exclusive, royalty-free license to use, reproduce, and display
          such content for the purpose of operating and improving the Service.
          You represent that you own or have rights to any User Content you
          submit and that it complies with these Terms.
        </P2>

        <H1 className="mt-50">7. Intellectual Property</H1>
        <P2 color={White} className="mt-10">
          All content, trademarks, and software on the Service are owned by Vibe
          Check or its licensors. You may not copy, distribute, or create
          derivative works without our express written permission.
        </P2>

        <H1 className="mt-50">8. Third-Party Services</H1>
        <P2 color={White} className="mt-10">
          Vibe Check integrates with third-party services such as Firebase
          (authentication, analytics) and Capacitor plugins. We are not
          responsible for their content, privacy practices, or policies.
        </P2>

        <H1 className="mt-50">9. Disclaimers</H1>
        <P2 color={White} className="mt-10">
          The Service and its compatibility results are for entertainment
          purposes only and provided “as is” without warranties of any kind. We
          disclaim all warranties, express or implied, including
          merchantability, fitness for a particular purpose, and
          non-infringement.
        </P2>

        <H1 className="mt-50">10. Limitation of Liability</H1>
        <P2 color={White} className="mt-10">
          To the fullest extent permitted by law, Vibe Check shall not be liable
          for any indirect, incidental, special, or consequential damages
          arising out of or related to your use of the Service.
        </P2>

        <H1 className="mt-50">11. Indemnification</H1>
        <P2 color={White} className="mt-10">
          You agree to defend, indemnify, and hold harmless Vibe Check from any
          claims, damages, or expenses resulting from your use of the Service or
          violation of these Terms.
        </P2>

        <H1 className="mt-50">12. Termination</H1>
        <P2 color={White} className="mt-10">
          We may suspend or terminate your access to the Service at our sole
          discretion, without prior notice, for any reason, including violation
          of these Terms.
        </P2>

        <H1 className="mt-50">13. Governing Law & Dispute Resolution</H1>
        <P2 color={White} className="mt-10">
          These Terms shall be governed by the laws of Los Angeles County,
          California, USA. Any disputes shall be resolved by binding arbitration
          in Los Angeles County, California, and you waive the right to
          participate in class actions.
        </P2>

        <H1 className="mt-50">14. Changes to Terms</H1>
        <P2 color={White} className="mt-10">
          We may update these Terms at any time. Updated Terms will be posted on
          our website and in the app. Continued use of the Service constitutes
          acceptance of the revised Terms.
        </P2>

        <H1 className="mt-50">15. Contact</H1>
        <P2 color={White} className="mt-10">
          For questions about these Terms, contact us at
          support@vibecheckme.com.
        </P2>

        <div
          className="mt-100"
          style={{
            color: White,
            fontSize: "11px",
            textAlign: "center",
          }}
        >
          <P3 className="mb-20">
            Made by{" "}
            <GradientSpan $background={Blue} $transitionBackground={Pink}>
              Clickbait Labs, Inc.
            </GradientSpan>{" "}
          </P3>
          <a
            className="text-decoration-none mr-10"
            href="https://www.vibecheckme.com/terms-of-service"
            style={{
              color: OffWhite,
            }}
          >
            Terms of Service
          </a>{" "}
          <a
            className="text-decoration-none mr-10"
            href="https://www.vibecheckme.com/privacy-policy"
            style={{
              color: OffWhite,
            }}
          >
            Privacy Policy
          </a>{" "}
          <a
            className="text-decoration-none"
            href="https://www.vibecheckme.com/delete-my-data"
            style={{
              color: OffWhite,
            }}
          >
            Delete My Data
          </a>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
